import React from 'react';
import { cn } from '../../utils/cn';

/**
 * BentoGrid - Responsive grid container for Bento cards
 *
 * @param {object} props - Component props
 * @param {React.ReactNode} props.children - Grid items (BentoCards)
 * @param {string} [props.className=''] - Additional CSS classes
 * @param {string} [props.gap='1rem'] - Gap between grid items
 */
const BentoGrid = ({
  children,
  className = '',
  gap = '1rem'
}) => {
  // Convert gap to responsive if it's a single value
  const gapStyle = gap.includes('rem') && !gap.includes(' ')
    ? { gap: `calc(${gap} * 0.75)`, '@media (min-width: 768px)': { gap: gap } }
    : { gap: gap };

  return (
    <div
      className={cn(
        'grid',
        'grid-cols-1',
        'md:grid-cols-2',
        'lg:grid-cols-3',
        className
      )}
      style={gapStyle}
    >
      {children}
    </div>
  );
};

export default BentoGrid;
